import { Card, Div, Hr, P, Space } from '@dnb/eufemia';
import { ApiDto } from '@portals/shared/portal/ApiDto';
import { PropsWithChildren, ReactNode } from 'react';

import style from './index.module.css';

interface Props {
  api: Pick<ApiDto, 'name' | 'type'>;
  headerContent?: ReactNode;
}

export default function ResourceCard({ api, headerContent, children }: PropsWithChildren<Props>) {
  return (
    <Card stretch>
      <Div className={style['title-type']}>{headerContent ?? <P weight="bold">{api.name}</P>}</Div>
      <Hr bottom="small" top="small" />
      <Space stretch>{children}</Space>
    </Card>
  );
}
